// @ts-nocheck
import React, { useState, useEffect } from 'react';
import Router, { useRouter } from 'next/router';
import SettingsMenu from '@/components/settings/menu';
import * as Enums from '@/utils/enums';
import Storage from '@/utils/storage';
import Helper from '@/utils/helper';
import {Flex} from "@mantine/core";
import SettingsWebFormList from "@/PageComponents/Table/Component Tables/SettingsWebFormList";
import { createFileRoute } from '@tanstack/react-router'



function WebFormList(props: any) {

    const router = useRouter();

    const [accessStatus, setAccessStatus] = useState(Enums.AccessStatus.None);
    const [customerStatus, setCustomerStatus] = useState<any>(null);

    const getAccessStatus = () => {
        let subscriptionInfo = Storage.getCookie(Enums.Cookie.subscriptionInfo);
        if (subscriptionInfo) {
            setAccessStatus(subscriptionInfo.AccessStatus);
            setCustomerStatus(subscriptionInfo.CustomerStatus);
        }
    }

    useEffect(() => {
        getAccessStatus();
    }, []);

    useEffect(() => {
        if (accessStatus === Enums.AccessStatus.LockedWithOutAccess && customerStatus !== "Trial" && customerStatus !== null) {
            Helper.nextRouter(Router.replace, "/");
        }
    }, [accessStatus, customerStatus]);


    useEffect(() => {
        if (accessStatus === Enums.AccessStatus.LockedWithOutAccess) {
            Helper.nextRouter(Router.replace, "/");
        }
    }, [accessStatus]);

    return (
        <div className="settings-container">
            <Flex>
                <SettingsMenu urlPath={router.asPath} />
                <div className="settings-card">
                    <SettingsWebFormList />
                </div>
            </Flex>
        </div>
    );
}

export default WebFormList;

export const Route = createFileRoute('/_authenticated/settings/webform/list')({ component: WebFormList })
